import React, { useCallback, useEffect, useState } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import CloseIcon from '../../../assets/icons/JSX/CloseIcon'
import RightArrow from '../../../assets/icons/JSX/RightArrow'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import Dropdown from '../../../components/v2/Dropdown'
import GenderCard from '../../../components/v2/GenderCard'
import Input from '../../../components/v2/Input'
import MovingPrice from '../../../components/v2/MovingPrice'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import WarningMessage from '../../../components/v2/WarningMessage'
import AddButton from '../../../components/v2/buttons/AddButton'
import Checkbox from '../../../components/v2/buttons/Checkbox'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import DialogModal from '../../../components/v2/modals/DialogModal'
import WelcomerProgressbar from '../../../components/v2/progrees-bars/WelcomerProgressbar'
import {
  GroupedWelcomerAttachedAddon,
  NewWelcomerAttachedAddon,
  WelcomerForMePersonalInfo,
} from '../../../domain/types'
import { RootState, useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import { AuthState } from '../../../store/authSlice'
import { WelcomerState, setWelcomers } from '../../../store/welcomerSlice'
import { Helmet } from 'react-helmet-async'

const WelcomerForMeAndOther = () => {
  //
  const { lang, isProduction } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useDispatch()
  //
  const { filter, screenHeader, checkout } = useAppSelector((data: { welcomer: WelcomerState }) => data.welcomer)
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetWelcomerPagesInfoQuery('welcomer-personal-info')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  //
  // countries array from api
  const { data: countries, isLoading: isCountriesLoading } = api.useGetCountriesQuery(undefined)
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const [sgsRequest, { data: sgsResult, isLoading: isSgsRequestLoading }] = api.useSgsRequestMutation()
  //
  const [openAccordion, setOpenAccordion] = useState<number | null>(0)
  //
  const _toggleAccordion = (index: number) => {
    if (openAccordion === index) {
      setOpenAccordion(null) // Close the currently open accordion
    } else {
      setOpenAccordion(index) // Open the clicked accordion
    }
  }
  //
  const [hideFields, setHideFields] = useState<boolean>(false)
  //
  const [termsModalIsOpen, setTermsModalIsOpen] = useState<boolean>(false)
  //
  //
  const closeTermsModal = () => {
    setTermsModalIsOpen(false)
  }
  //
  //
  type PersonalInfos = {
    UserPersonalInfos: Partial<WelcomerForMePersonalInfo>[]
  }
  //
  //
  // english letter regex
  const englishLetterRegex = /^[A-Za-z]+$/
  //
  const georgianLetterRegex = /^[\u10D0-\u10FF]*$/
  //
  const letterNumberRegex = /^[a-zA-Z0-9]*$/
  // #############################################################
  //
  //
  const [welcomersCountState] = useState<number | undefined>(filter.welcomersDate?.length)
  //
  //
  //
  // welcomers array
  const [welcomersInfo, setWelcomersInfo] = useState<Partial<WelcomerForMePersonalInfo>[]>(
    checkout.welcomers
      ? checkout.welcomers
      : [
          {
            consentTerm: false,
            cityzenship: 'GE',
            passportNumber: '',
            idNumber: '',
            email: '',
            dateOfbirth: null,
            gender: '',
            sgsVerification: false,
            sgsVerificationSended: false,
            translations: {
              ge: {
                firstName: '',
                lastName: '',
              },
              en: {
                firstName: '',
                lastName: '',
              },
            },
          },
        ],
  )
  //
  //
  //
  //
  // add welcomer
  const handleAddWelcomer = () => {
    append({
      cityzenship: 'GE',
      passportNumber: '',
      idNumber: '',
      email: '',
      dateOfbirth: null,
      gender: '',
      sgsVerification: false,
      sgsVerificationSended: false,
      translations: {
        ge: {
          firstName: '',
          lastName: '',
        },
        en: {
          firstName: '',
          lastName: '',
        },
      },
    })
  }
  //
  //
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm<PersonalInfos>({ defaultValues: { UserPersonalInfos: welcomersInfo }, mode: 'all' })

  const { append, remove } = useFieldArray({
    control: control,
    name: 'UserPersonalInfos',
    rules: {
      required: { value: true, message: 'Add At least one field' },
    },
  })
  //
  //
  //
  const onSubmit = (userPersonalInfos: PersonalInfos, event: any) => {
    //
    event.preventDefault()
    //
    setWelcomersInfo(userPersonalInfos.UserPersonalInfos)
    //
    dispatch(setWelcomers(welcomersInfo))
    //
    navigate('/welcomer-check-information')
    //
  }
  //
  //
  // set welcomers in current page state
  const data = watch('UserPersonalInfos')
  //
  useEffect(() => {
    setWelcomersInfo(data)
  }, [data])
  //
  //
  //
  //
  // add welcomer cityzenship
  const handleWelcomerCityzenship = (fieldName: string, value: any, index: any) => {
    setValue(`UserPersonalInfos.${index}.cityzenship`, value)
  }
  //
  //
  const userPersonalNumbers = welcomersInfo?.map((x) => x?.idNumber)
  //
  const userPassportNumbers = welcomersInfo?.map((x) => x?.passportNumber)
  //
  //
  // find duplicate info & personal number & pasport number
  const hasDuplicates = (arr: string[]) => {
    let set = new Set()
    for (let item of arr) {
      if (set.has(item) && item.trim().length >= 2) {
        return true
      } else {
        set.add(item)
      }
    }
    return false
  }
  //
  //
  // #############################################################
  //
  //
  const welcomersAgeFromRedux = filter.welcomersDate?.map((x, i) => `${x.date}-${i}`)
  //
  //
  const incomeDateCounts = {}
  welcomersAgeFromRedux?.forEach(function (x) {
    // @ts-ignore
    incomeDateCounts[x] = (incomeDateCounts[x] || 0) + 1
  })
  //
  //
  const welcomersDateFromCurrentPage = welcomersInfo?.map((x) => x.dateOfbirth)
  //
  const currentDateCounts = {}
  welcomersDateFromCurrentPage?.forEach(function (x) {
    // @ts-ignore
    currentDateCounts[x] = (currentDateCounts[x] || 0) + 1
  })
  //
  //
  //
  // check user dates
  const isDeepEqual = (object1: any, object2: any) => {
    const objKeys1 = Object.keys(object1)
    const objKeys2 = Object.keys(object2)

    if (objKeys1.length !== objKeys2.length) return false

    for (var key of objKeys1) {
      const value1 = object1[key]
      const value2 = object2[key]

      const isObjects = isObject(value1) && isObject(value2)

      if ((isObjects && !isDeepEqual(value1, value2)) || (!isObjects && value1 !== value2)) {
        return false
      }
    }
    return true
  }

  const isObject = (object: any) => {
    return object != null && typeof object === 'object'
  }
  //
  //
  //
  // dates equal variable
  const isWelcomersDateEqual: boolean = isDeepEqual(incomeDateCounts, currentDateCounts)
  //
  //
  //
  //
  //####################################################
  // add uset at addon
  const addUserAtAddon = (index: number, addon: NewWelcomerAttachedAddon) => {
    const list = [...welcomersInfo]
    const existingUserAddons = list[index].addons || []
    list[index]['addons'] = [...existingUserAddons, addon]
    //
    setWelcomersInfo(list)
  }
  //
  // remove user at addon
  const removeUserAtAddon = (index: number, addon: NewWelcomerAttachedAddon) => {
    const list = [...welcomersInfo]
    const existingUserAddons = list[index].addons || []
    list[index].addons = existingUserAddons.filter((x) => x.addonId !== addon.addonId)
    setWelcomersInfo(list)
  }

  //
  //
  // add group addon
  const addGroupUserAtAddon = (index: number, addon: GroupedWelcomerAttachedAddon) => {
    const list = [...welcomersInfo]
    const existingUserAddons = list[index].groupedAddonInfos || []
    list[index]['groupedAddonInfos'] = [...existingUserAddons, addon]
    //
    setWelcomersInfo(list)
  }
  //
  // remove user group  addon
  const removeUserGroupAtAddon = (index: number, addon: GroupedWelcomerAttachedAddon) => {
    const list = [...welcomersInfo]
    const existingUserAddons = list[index].groupedAddonInfos || []
    list[index].groupedAddonInfos = existingUserAddons.filter((x) => x.id !== addon.id)
    setWelcomersInfo(list)
  }

  //####################################################
  // ############### at addons
  const calculateAtAddonCounts = (welcomers: Partial<WelcomerForMePersonalInfo>[]) => {
    const atAddonCounts = {}
    //
    if (welcomers) {
      //
      welcomersInfo.forEach((welcomer) => {
        welcomer?.addons?.forEach((addon) => {
          const addonId = addon.addonId
          // @ts-ignore
          if (atAddonCounts[addonId]) {
            // @ts-ignore
            atAddonCounts[addonId]++
          } else {
            // @ts-ignore
            atAddonCounts[addonId] = 1
          }
        })
      })
      //
      return atAddonCounts
    }
  }
  //
  const atAddonCounts = calculateAtAddonCounts(welcomersInfo)
  // ############### at addons
  //
  //
  const welcomersDateArr = filter.welcomersDate?.map((t, i) => ({
    value: `${t.date}-${i}`,
    label: t.date,
    dateFormat: t.dateFormat,
  }))
  //
  // ################################################ set insurer info
  //
  //
  const setInsurerInfoCallback = useCallback(() => {
    //
    const list = [...welcomersInfo]
    //
    if (
      auth &&
      auth.user &&
      auth.user.userType === 'User' &&
      auth.user.sgsVerification === true &&
      auth.user.personalNumber &&
      auth.user.personalNumber.length === 11 &&
      auth.user.birthday &&
      list[0] &&
      list[0].cityzenship &&
      list[0].translations &&
      list[0].translations.ge &&
      list[0].translations.en &&
      list[0].sgsVerificationSended === false
    ) {
      //
      list[0].cityzenship = auth.user.citizenship
      list[0].idNumber = auth.user.personalNumber
      // @ts-ignore
      list[0].dateOfbirth = welcomersDateArr?.find((x) => x.dateFormat === auth.user?.birthday)?.value
      list[0].passportNumber = auth.user.passportNumber
      list[0].translations.ge.firstName = auth.user.firstNameGe
      list[0].translations.ge.lastName = auth.user.lastNameGe
      list[0].translations.en.firstName = auth.user.firstName
      list[0].translations.en.lastName = auth.user.lastName
      list[0].gender = auth.user.gender
      list[0].sgsVerification = auth.user.sgsVerification
      list[0].sgsVerificationSended = true
      //
      setValue(`UserPersonalInfos.${0}.consentTerm`, auth.user.agreeToTerms.consentTerm)
      //
      //
    }
    //
  }, [auth, setValue, welcomersInfo, welcomersDateArr])
  //
  //
  useEffect(() => {
    setInsurerInfoCallback()
    //
    return () => {}
  }, [setInsurerInfoCallback])
  //
  // ################################################ set insurer info
  //

  // ############### group at addons
  const calculateGroupAtAddonCounts = (welcomers: Partial<WelcomerForMePersonalInfo>[]) => {
    const groupAtAddonCounts = {}
    //
    if (welcomers) {
      //
      welcomersInfo.forEach((welcomer) => {
        welcomer?.groupedAddonInfos?.forEach((addon) => {
          const addonId = addon.id
          // @ts-ignore
          if (groupAtAddonCounts[addonId]) {
            // @ts-ignore
            groupAtAddonCounts[addonId]++
          } else {
            // @ts-ignore
            groupAtAddonCounts[addonId] = 1
          }
        })
      })
      //
      return groupAtAddonCounts
    }
  }
  //
  const groupAtAddonCounts = calculateGroupAtAddonCounts(welcomersInfo)
  // ############### group at addons
  //
  const gendersIsValid = welcomersInfo
    ?.map((x) => (x.gender !== undefined && x?.gender?.length <= 1 ? false : true))
    ?.every((value) => value)
  //
  //
  //
  const handleKeyDown = (event: any) => {
    if (event?.key === 'Enter') {
      event.preventDefault()
    }
  }
  //
  //
  // ######################################## BEGIN S G S
  //
  //
  //
  const convertDateFormat = (inputDate?: string) => {
    if (inputDate !== undefined) {
      const parts = inputDate.split(' / ')
      if (parts.length === 3) {
        const day = parts[0]
        const month = parts[1]
        const year = parts[2].split('-')[0] // Extract the year part before the hyphen
        const formattedDate = `${year}-${month}-${day}`
        return formattedDate
      } else {
        return 'Invalid date format'
      }
    }
    return 'Invalid input'
  }
  //
  //
  // send sgs request by birthday and personal number
  const sendSgsRequest = async (birthday: string, personalNumber: string) => {
    //
    if (birthday && personalNumber) {
      try {
        //
        await sgsRequest({ birthday, personalNumber }).unwrap()
        //
      } catch (error: any) {
        //
        setHideFields(false)
        //
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0]
          const errorMessage = firstError.message
          toast.error(errorMessage)
        }
      }
    }
    //
  }
  //
  //
  //
  // check user end send sgs request & set traveler sgs request is sended or not
  useEffect(() => {
    //
    if (welcomersInfo && welcomersInfo.length >= 1 && isProduction) {
      //
      welcomersInfo.map((welcomer, index) => {
        if (
          welcomer.sgsVerificationSended === false &&
          welcomer.sgsVerification === false &&
          welcomer.dateOfbirth &&
          welcomer.cityzenship &&
          welcomer.cityzenship === 'GE' &&
          welcomer.idNumber &&
          welcomer.idNumber.length === 11
        ) {
          //
          // format welcomer custom date to normal date
          const welcomerDate = convertDateFormat(welcomer.dateOfbirth as unknown as string)
          //
          // set welcomer sgs request is sended
          setValue(`UserPersonalInfos.${index}.sgsVerificationSended`, true)
          //
          // send request in sgs service
          sendSgsRequest(welcomerDate, welcomer.idNumber)
          //
          // hide fields
          setHideFields(true)
          //
          //
          return null
          //
        } else {
          return null
        }
      })
      //
    }
    //
    return () => {}
  })
  //
  //
  //
  // lock sgs response and is return welcomer info, update current welcomer info or return current welcomer prev info
  const setResponsedWelcomerInfo = useCallback(async () => {
    //
    const updatedWelcomer = data?.find((x) => x?.idNumber === sgsResult?.personalNumber)
    //
    //
    if (
      isProduction &&
      sgsResult &&
      sgsResult.sgsStatusText &&
      sgsResult.sgsStatusText.toLowerCase() === 'ok' &&
      data &&
      (updatedWelcomer ? true : false) &&
      updatedWelcomer?.sgsVerification === false &&
      updatedWelcomer?.sgsVerificationSended === true
    ) {
      //
      const updatedWelcomer: Partial<WelcomerForMePersonalInfo>[] = data?.map((welcomer) => {
        //
        if (welcomer.idNumber === sgsResult.personalNumber) {
          return {
            ...welcomer,
            gender: sgsResult.gender,
            sgsVerification: true,
            sgsVerificationSended: true,
            translations: {
              ge: {
                firstName: sgsResult.translations?.ge?.firstName,
                lastName: sgsResult.translations?.ge?.lastName,
              },
              en: {
                firstName: sgsResult.translations?.en?.firstName,
                lastName: sgsResult.translations?.en?.lastName,
              },
            },
          }
          //
        } else {
          //
          return welcomer
          //
        }
      })
      //
      // setTravelersInfo(updatetTraveler)
      setValue(`UserPersonalInfos`, updatedWelcomer)
      //
      // show fields
      setHideFields(false)
      //
      //
    } else {
      // show fields
      setHideFields(false)
    }
    //
  }, [isProduction, data, sgsResult, setValue])
  //
  //
  useEffect(() => {
    setResponsedWelcomerInfo()
    //
    return () => {}
  }, [setResponsedWelcomerInfo])
  //
  //
  // ######################################## END S G S
  //
  //
  //
  //#################### NEXT STEP VALIDATIONS
  //
  const idNumbersIsValid =
    welcomersInfo?.filter((x) => x.cityzenship === 'GE' && x.idNumber && x.idNumber.length === 11).length ===
    welcomersInfo?.filter((x) => x.cityzenship === 'GE').length
  //
  const cityzenshipsIsValid = welcomersInfo.filter((x) => x.cityzenship).length === filter.welcomersDate?.length
  //
  const passportsIsValid =
    welcomersInfo?.filter((x) => x.cityzenship !== 'GE' && x.passportNumber).length ===
    welcomersInfo?.filter((x) => x.cityzenship !== 'GE').length
  //
  //#################### NEXT STEP VALIDATIONS
  //
  //
  //
  // get standart addons selected count by id
  function calculateStandartAddonCounts(welcomers: Partial<WelcomerForMePersonalInfo>[]) {
    const addonCounts = {}

    welcomers.forEach((welcomer) => {
      const addons = welcomer.addons
      if (addons && Array.isArray(addons)) {
        addons.forEach((addon) => {
          const { addonId } = addon
          // @ts-ignore
          if (addonCounts[addonId]) {
            // @ts-ignore
            addonCounts[addonId]++
          } else {
            // @ts-ignore
            addonCounts[addonId] = 1
          }
        })
      }
    })

    const addonsWithCount = Object.keys(addonCounts).map((addonId) => ({
      addonId: parseInt(addonId),
      // @ts-ignore
      count: addonCounts[addonId],
    }))

    return addonsWithCount
  }
  //
  //
  // get grouped addons selected count by id
  function calculateGroupedAddonCounts(welcomers: Partial<WelcomerForMePersonalInfo>[]) {
    const addonCounts = {}

    welcomers.forEach((welcomer) => {
      const addons = welcomer.groupedAddonInfos
      if (addons && Array.isArray(addons)) {
        addons.forEach((addon) => {
          const { id } = addon
          // @ts-ignore
          if (addonCounts[id]) {
            // @ts-ignore
            addonCounts[id]++
          } else {
            // @ts-ignore
            addonCounts[id] = 1
          }
        })
      }
    })

    const addonsWithCount = Object.keys(addonCounts).map((addonId) => ({
      addonId: parseInt(addonId),
      // @ts-ignore
      count: addonCounts[addonId],
    }))

    return addonsWithCount
  }
  //
  //
  const standartAddonSelectedCountByid = calculateStandartAddonCounts(welcomersInfo)
  const groupedAddonSelectedCountByid = calculateGroupedAddonCounts(welcomersInfo)
  //
  //
  const standartAddonTotalCount =
    standartAddonSelectedCountByid?.reduce((total, welcomer) => total + welcomer.count, 0) || 0
  const groupedAddonTotalCount =
    groupedAddonSelectedCountByid?.reduce((total, welcomer) => total + welcomer.count, 0) || 0
  //
  //
  const standartAddonFromFilter = filter.attachedAddons?.reduce((prev, next) => prev + next.count, 0) || 0
  const groupedAddonFromFilter = filter.groupedAttachedAddons?.reduce((prev, next) => prev + next.count, 0) || 0
  //
  //
  const totalUsedAddonCount = standartAddonTotalCount + groupedAddonTotalCount
  const totalFilterAddonCount = standartAddonFromFilter + groupedAddonFromFilter
  //
  //
  const notUsedAddonCount = totalFilterAddonCount - totalUsedAddonCount
  //
  //
  const allAddonIsSelected = totalFilterAddonCount === totalUsedAddonCount ? true : false
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.singleDates?.start) {
      navigate('/welcomer-start-date')
    }
    //
    return () => {}
  }, [filter.singleDates?.start, navigate])
  //
  //
  const MainLoading = isCountriesLoading || isSgsRequestLoading || isPageInfoLoading

  return MainLoading ? (
    <Loader text={isSgsRequestLoading ? `${t('dataProcessing')}` : ''} />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      {/*  */}
      <DialogModal
        title={t('consent')}
        isOpen={termsModalIsOpen}
        onClose={closeTermsModal}
        src={`${document.location.origin}/consent-dialog`}
        acceptOnClick={() => [setValue(`UserPersonalInfos.${0}.consentTerm`, true), closeTermsModal()]}
        //
        declineOnClick={() => [setValue(`UserPersonalInfos.${0}.consentTerm`, false), closeTermsModal()]}
      />

      {/*  */}

      <form onSubmit={(event) => event.preventDefault()}>
        <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

        {hideFields ? null : (
          <Content>
            <Title text={pageTitle} />

            <WelcomerProgressbar stepName={stepName || ''} />

            <MovingPrice price={filter.offerTotalPrice} />

            {welcomersInfo?.map((item, index) => {
              //
              //
              return (
                <WhiteBox key={index}>
                  <BlockHead>
                    <CloseButton onClick={() => _toggleAccordion(index)}>
                      <RightArrow
                        style={{
                          transform: openAccordion === index ? `rotate(0deg)` : `rotate(-180deg)`,
                        }}
                      />
                    </CloseButton>
                    <BoxTitle onClick={() => _toggleAccordion(index)}>
                      {index === 0 ? `${t('insurerInformation')}` : `${t('traveller')}`} {index >= 1 ? index + 1 : null}
                    </BoxTitle>
                    <RemoveBtn
                      style={{
                        pointerEvents: index === 0 ? 'none' : 'unset',
                        userSelect: index === 0 ? 'none' : 'unset',
                        opacity: index === 0 ? '0' : 'unset',
                      }}
                      type="button"
                      onClick={() => remove(index)}
                    >
                      <CloseIcon />
                    </RemoveBtn>
                  </BlockHead>

                  {openAccordion === index ? (
                    <Inputs>
                      {countries && (
                        <Dropdown
                          title={`${t('cityzenship')}`}
                          isSearchable={true}
                          value={item.cityzenship || ''}
                          options={[
                            ...countries.map((c) => ({
                              value: c.isoCode,
                              label: c.translations?.[lang]?.name,
                            })),
                          ]}
                          onChange={(event) => handleWelcomerCityzenship('cityzenship', event.value, index)}
                        />
                      )}

                      <Input
                        id={`welcomer-id-number-${index}`}
                        label={t('personalNumber')}
                        type="text"
                        placeholder=""
                        value={item.idNumber}
                        name={`UserPersonalInfos.${index}.idNumber`}
                        width={'fullWidth'}
                        error={!!errors.UserPersonalInfos?.[index]?.idNumber}
                        errorText={errors.UserPersonalInfos?.[index]?.idNumber?.message}
                        formRegistration={register(`UserPersonalInfos.${index}.idNumber`, {
                          required: { value: item.cityzenship === 'GE' ? true : false, message: `${t('required')}` },
                          minLength:
                            item.cityzenship === 'GE'
                              ? { value: 11, message: `${t('personalNumberValidation')}` }
                              : undefined,
                          maxLength:
                            item.cityzenship === 'GE'
                              ? { value: 11, message: `${t('personalNumberValidation')}` }
                              : undefined,
                          pattern: {
                            value: item.cityzenship === 'GE' ? /^[0-9]+$/ : letterNumberRegex,
                            message:
                              item.cityzenship === 'GE' ? `${t('numberValidation')}` : `${t('letterNumberValidation')}`,
                          },
                        })}
                        onKeyPress={handleKeyDown}
                      />

                      {hasDuplicates(userPersonalNumbers as string[]) ? ( // probable error
                        <WarningMessage variant="gray" text={t('duplicatePersonalNumber')} />
                      ) : null}

                      {filter && filter.welcomersDate && (
                        <Dropdown
                          title={`${t('dateOfBirth')}`}
                          isSearchable={false}
                          value={watch(`UserPersonalInfos.${index}.dateOfbirth`) || ''}
                          options={welcomersDateArr}
                          onChange={(event) => setValue(`UserPersonalInfos.${index}.dateOfbirth`, event.value)}
                        />
                      )}

                      <Input
                        id={`welcomer-passport-number-${index}`}
                        label={t('passportNumber')}
                        type="text"
                        placeholder=""
                        value={item.passportNumber}
                        name={`UserPersonalInfos.${index}.passportNumber`}
                        width={'fullWidth'}
                        error={!!errors.UserPersonalInfos?.[index]?.passportNumber}
                        errorText={errors.UserPersonalInfos?.[index]?.passportNumber?.message}
                        formRegistration={register(`UserPersonalInfos.${index}.passportNumber`, {
                          required: { value: item.cityzenship === 'GE' ? false : true, message: `${t('required')}` },
                          maxLength: {
                            value: item.cityzenship === 'GE' ? 9 : 30,
                            message: `${t('passportNumberValidation')}`,
                          },
                          pattern: {
                            value: letterNumberRegex,
                            message: `${t('letterNumberValidation')}`,
                          },
                        })}
                        onKeyPress={handleKeyDown}
                      />

                      {hasDuplicates(userPassportNumbers as string[]) ? ( // probable error
                        <WarningMessage variant="gray" text={t('duplicatePassportNumber')} />
                      ) : null}

                      {item.cityzenship === 'GE' && (
                        <Input
                          id={`welcomer-name-georgian-${index}`}
                          label={t('nameInGeorgia')}
                          type="text"
                          placeholder=""
                          value={item.translations?.ge?.firstName}
                          name={`UserPersonalInfos.${index}.translations.ge.firstName`}
                          width={'fullWidth'}
                          error={!!errors.UserPersonalInfos?.[index]?.translations?.ge?.firstName}
                          errorText={errors.UserPersonalInfos?.[index]?.translations?.ge?.firstName?.message}
                          formRegistration={register(`UserPersonalInfos.${index}.translations.ge.firstName`, {
                            required: { value: item.cityzenship === 'GE', message: `${t('required')}` },
                            pattern: {
                              value: georgianLetterRegex,
                              message: `${t('enterGeorgianLetterAndRemoveSpaceValidation')}`,
                            },
                            minLength: { value: 2, message: `${t('minNameLetterLenght')}` },
                          })}
                          onKeyPress={handleKeyDown}
                        />
                      )}

                      {item.cityzenship === 'GE' && (
                        <Input
                          id={`welcomer-surname-georgian-${index}`}
                          label={t('surnameInGeorgia')}
                          type="text"
                          placeholder=""
                          value={item.translations?.ge?.lastName}
                          name={`UserPersonalInfos.${index}.translations.ge.lastName`}
                          width={'fullWidth'}
                          error={!!errors.UserPersonalInfos?.[index]?.translations?.ge?.lastName}
                          errorText={errors.UserPersonalInfos?.[index]?.translations?.ge?.lastName?.message}
                          formRegistration={register(`UserPersonalInfos.${index}.translations.ge.lastName`, {
                            required: { value: item.cityzenship === 'GE', message: `${t('required')}` },
                            pattern: {
                              value: georgianLetterRegex,
                              message: `${t('enterGeorgianLetterAndRemoveSpaceValidation')}`,
                            },
                            minLength: { value: 2, message: `${t('minSurnameLetterLenght')}` },
                          })}
                          onKeyPress={handleKeyDown}
                        />
                      )}

                      <Input
                        id={`name-english${index}`}
                        label={t('nameInEnglish')}
                        type="text"
                        placeholder=""
                        value={item.translations?.en?.firstName}
                        name={`UserPersonalInfos.${index}.translations.en.firstName`}
                        width={'fullWidth'}
                        error={!!errors.UserPersonalInfos?.[index]?.translations?.en?.firstName}
                        errorText={errors.UserPersonalInfos?.[index]?.translations?.en?.firstName?.message}
                        formRegistration={register(`UserPersonalInfos.${index}.translations.en.firstName`, {
                          required: { value: true, message: `${t('required')}` },
                          pattern: {
                            value: englishLetterRegex,
                            message: `${t('enterEnglishLetterAndRemoveSpaceValidation')}`,
                          },
                          minLength: { value: 2, message: `${t('minNameLetterLenght')}` },
                        })}
                        onKeyPress={handleKeyDown}
                      />

                      <Input
                        id={`surname-english-${index}`}
                        label={t('surnameInEnglish')}
                        type="text"
                        placeholder=""
                        value={item.translations?.en?.lastName}
                        name={`UserPersonalInfos.${index}.translations.en.lastName`}
                        width={'fullWidth'}
                        error={!!errors.UserPersonalInfos?.[index]?.translations?.en?.lastName}
                        errorText={errors.UserPersonalInfos?.[index]?.translations?.en?.lastName?.message}
                        formRegistration={register(`UserPersonalInfos.${index}.translations.en.lastName`, {
                          required: { value: true, message: `${t('required')}` },
                          pattern: {
                            value: englishLetterRegex,
                            message: `${t('enterEnglishLetterAndRemoveSpaceValidation')}`,
                          },
                          minLength: { value: 2, message: `${t('minSurnameLetterLenght')}` },
                        })}
                        onKeyPress={handleKeyDown}
                      />

                      <ChooseGenderLabel style={{ color: errors.UserPersonalInfos?.[index]?.gender ? 'red' : 'black' }}>
                        {t('chooseGender')}
                      </ChooseGenderLabel>
                      <GenderBlock>
                        <GenderCard
                          selected={watch(`UserPersonalInfos.${index}.gender`) === 'female'}
                          gender="female"
                          femaleText={`${t('female')}`}
                          onClick={() => setValue(`UserPersonalInfos.${index}.gender`, 'female')}
                        />

                        <GenderCard
                          selected={watch(`UserPersonalInfos.${index}.gender`) === 'male'}
                          gender="male"
                          maleText={`${t('male')}`}
                          onClick={() => setValue(`UserPersonalInfos.${index}.gender`, 'male')}
                        />
                      </GenderBlock>

                      {index === 0 ? (
                        <Checkbox
                          id="for-me-frani-terms"
                          label={`${t('franiTermsText')}`}
                          checked={item.consentTerm ?? false}
                          defaultChecked={item.consentTerm ?? false}
                          onClick={() => setTermsModalIsOpen(true)}
                        />
                      ) : null}

                      {(filter.attachedAddons && filter.attachedAddons.length >= 1) ||
                      (filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1) ? (
                        <AddonBlock>
                          <hr />
                          <AddonsLabel>{t('chooseExtraCoverages')}</AddonsLabel>
                          <AddonItems>
                            {filter.attachedAddons?.map((atAddon, atAddonIndex) => {
                              //
                              //
                              // @ts-ignore
                              const countIsEqual = (atAddonCounts?.[atAddon?.addon?.addonId] || 0) === atAddon.count
                              //
                              //
                              const welcomerHaveAddon = item.addons?.find((x) => x.addonId === atAddon.addon.addonId)
                                ? true
                                : false
                              //
                              //
                              const showAddon = !countIsEqual || (countIsEqual && welcomerHaveAddon)
                              //
                              //
                              if (showAddon) {
                                return (
                                  <AddonItem key={atAddonIndex}>
                                    <Checkbox
                                      id={`at-addon-id-${atAddonIndex}`}
                                      label={atAddon?.addon?.addon?.translations[lang]?.title || ''}
                                      defaultChecked={
                                        item.addons?.find((x) => x.addonId === atAddon.addon.addonId) ? true : false
                                      }
                                      onChange={(value) => {
                                        // add addon
                                        if (value === true) {
                                          addUserAtAddon(index, atAddon.addon)
                                        }
                                        // remove addon
                                        if (value === false) {
                                          removeUserAtAddon(index, atAddon.addon)
                                        }
                                      }}
                                    />
                                    <span>
                                      {atAddon.addon.paymentType === 'DAILY'
                                        ? parseFloat(atAddon.addon.premium) * (filter?.insuranceDays || 0)
                                        : parseFloat(atAddon.addon.premium)}{' '}
                                      ₾
                                    </span>
                                  </AddonItem>
                                )
                              } else {
                                return null
                              }
                              //
                            })}

                            {filter.groupedAttachedAddons?.map((groupAtAddon, groupAtAddonIndex) => {
                              //
                              //
                              const countIsEqual =
                                // @ts-ignore
                                (groupAtAddonCounts?.[groupAtAddon?.addon?.id] || 0) === groupAtAddon.count
                              //
                              //
                              const welcomersHaveAddon = item.groupedAddonInfos?.find(
                                (x) => x.id === groupAtAddon.addon.id,
                              )
                                ? true
                                : false
                              //
                              //
                              const showAddon = !countIsEqual || (countIsEqual && welcomersHaveAddon)
                              //
                              //
                              if (showAddon) {
                                return (
                                  <AddonItem key={groupAtAddonIndex}>
                                    <Checkbox
                                      id={`group-addon-id-${groupAtAddonIndex}`}
                                      label={groupAtAddon?.addon?.translations?.[lang]?.title || ''}
                                      defaultChecked={
                                        item.groupedAddonInfos?.find((x) => x.id === groupAtAddon.addon.id)
                                          ? true
                                          : false
                                      }
                                      onChange={(value) => {
                                        // add addon
                                        if (value === true) {
                                          addGroupUserAtAddon(index, groupAtAddon.addon)
                                        }
                                        // remove addons
                                        if (value === false) {
                                          removeUserGroupAtAddon(index, groupAtAddon.addon)
                                        }
                                      }}
                                    />
                                    <span>
                                      {groupAtAddon.addon.paymentType === 'DAILY'
                                        ? groupAtAddon.addon.premium * (filter?.insuranceDays || 0)
                                        : groupAtAddon.addon.premium}{' '}
                                      ₾
                                    </span>
                                  </AddonItem>
                                )
                              } else {
                                return null
                              }
                            })}
                          </AddonItems>
                        </AddonBlock>
                      ) : null}

                      {allAddonIsSelected !== true && totalFilterAddonCount && totalFilterAddonCount >= 1 ? (
                        <WarningMessage
                          variant="gray"
                          text={`${t('youHave')}  ${notUsedAddonCount} ${t('unusedCoverage')}`}
                        />
                      ) : null}
                    </Inputs>
                  ) : null}
                </WhiteBox>
              )
            })}

            {(welcomersCountState && welcomersInfo && welcomersInfo.length === welcomersCountState) ||
            (welcomersCountState && welcomersInfo && welcomersInfo.length > welcomersCountState) ? null : (
              <AddButtonStyle>
                <AddButton
                  text={t('addTraveler')}
                  onClick={() => [handleAddWelcomer(), _toggleAccordion((openAccordion as number) + 1)]}
                />
              </AddButtonStyle>
            )}

            <Buttons>
              <NavigationButton
                text={`${t('back')}`}
                buttonType="prev"
                onClick={() => navigate('/welcomer-who-do-you-insure')}
              />
              <NavigationButton
                text={`${t('next')}`}
                disabled={
                  isWelcomersDateEqual === true &&
                  allAddonIsSelected === true &&
                  idNumbersIsValid &&
                  cityzenshipsIsValid &&
                  passportsIsValid &&
                  welcomersInfo?.[0]?.consentTerm === true &&
                  gendersIsValid === true &&
                  (hasDuplicates(userPassportNumbers as string[]) === true ? false : true) &&
                  (hasDuplicates(userPersonalNumbers as string[]) === true ? false : true)
                    ? false
                    : true
                }
                buttonType="next"
                onClick={handleSubmit(onSubmit)}
              />
            </Buttons>
          </Content>
        )}
      </form>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
//
// styles
//
const AddButtonStyle = styled.div`
  margin-top: 60px;
  display: grid;
  place-items: center;
`
const CloseButton = styled.button`
  background-color: transparent;
  border: unset;
  outline: unset;
  padding: 5px;
  margin: 0px;
  display: grid;
  place-items: center;
  transform: rotate(-90deg);
  position: absolute;
  left: 14px;

  &:active {
    opacity: 0.8;
  }

  svg {
    width: 17px;
    height: 14px;
    color: ${Colors.primaryBlack};
  }

  ${Responsive.mobile} {
    left: 12px;
  }
`
const RemoveBtn = styled.button`
  background-color: transparent;
  border: unset;
  outline: unset;
  padding: 5px;
  margin: 0px;
  display: grid;
  place-items: center;
  position: absolute;
  top: 16px;
  right: 16px;

  &:active {
    opacity: 0.8;
  }

  svg {
    width: 16px;
    height: 13px;
    color: ${Colors.nevadaGrey};
  }

  ${Responsive.mobile} {
    svg {
      width: 14px;
      height: 11px;
    }
  }
`
const BlockHead = styled.div`
  display: flex;
  align-items: center;
`
const AddonItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const AddonItems = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 14px;
`
const AddonBlock = styled.div`
  /*  */
`
const AddonsLabel = styled.label`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 25px;
  ${Responsive.mobile} {
    font-size: 14px;
  }
`
const GenderBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
`
const ChooseGenderLabel = styled.label`
  font-size: 14px;
  color: ${Colors.primaryGrey};
`
const Inputs = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 20px;
  margin-top: 20px;
`
const WhiteBox = styled.div`
  background-color: ${Colors.white};
  margin-block: 32px;
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  max-width: 464px;
  width: 100%;
  margin-inline: auto;
  border-radius: 8px;
  padding: 34px 48px;
  position: relative;

  ${Responsive.mobile} {
    padding: 25px 20px;
    width: 100%;
  }
`
const BoxTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin: 0px;
  cursor: pointer;
  user-select: none;

  ${Responsive.mobile} {
    margin-left: 25px;
  }
`
const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`
const Content = styled.div`
  position: relative;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
  form {
    width: 100%;
  }
`
//

export default WelcomerForMeAndOther
